import { memo, useState, useMemo } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Octo from '../components/Octo';
import { ReactComponent as Logo } from '../assets/images/logo-dark-short.svg';

const Footer = memo(() => {
  const [tic, setTic] = useState(1);
  const year = useMemo(() => moment().format('YYYY'), []);
  return (
    <div className="protean-footer" id="protean-footer">
      <div className="rights-block">
        <Octo show={tic} />
        <Logo className="d-inline-block" onClick={() => setTic(tic + 1)} />
        <span>{`© ${year} PROTEAN VENTURES LLC. All rights reserved`}</span>
      </div>
      <div className="terms-block">
        <Link to="/terms_of_service">Terms of Service</Link>
      </div>
    </div>
  );
});

export default Footer;
